import { render, staticRenderFns } from "./ChoosePlanDesk.vue?vue&type=template&id=211a808f&scoped=true&"
import script from "./ChoosePlanDesk.vue?vue&type=script&lang=js&"
export * from "./ChoosePlanDesk.vue?vue&type=script&lang=js&"
import style0 from "./ChoosePlanDesk.vue?vue&type=style&index=0&id=211a808f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211a808f",
  null
  
)

export default component.exports